import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_uefa_team_table = _resolveComponent("uefa-team-table")!
  const _component_widget_block = _resolveComponent("widget-block")!

  return _withDirectives((_openBlock(), _createBlock(_component_widget_block, {
    title: _ctx.title,
    "show-divider": !!_ctx.title,
    "btn-label": _ctx.btnLabel,
    "btn-url": _ctx.btnUrl
  }, {
    default: _withCtx(() => [
      _createVNode(_component_uefa_team_table, { contents: _ctx.teamStat }, null, 8, ["contents"])
    ]),
    _: 1
  }, 8, ["title", "show-divider", "btn-label", "btn-url"])), [
    [_vShow, _ctx.teamStat.length]
  ])
}